import React, { useState } from "react";
import * as Types from "../types/BaseTypes";
import Category from "../objects/Category";
import Slider from "./Slider";

import * as CategoryImages from "../images/categories";

import { useTransition, animated } from "react-spring";

export default (props: {
  core: Types.Core;
  setCore: Function;
  next: Function;
  prev: Function;
}) => {
  const { core, setCore, next, prev } = props;

  const getSliderLeft = () => {
    switch (core.category) {
      case Types.Category.a: {
        return 0;
      }
      case Types.Category.b: {
        return 1;
      }
      case Types.Category.c: {
        return 2;
      }
      default:
        return 0;
    }
  };

  const getSliderLeft2 = () => {
    switch (core.application) {
      case Types.Application.OtherApplications: {
        return 0;
      }
      case Types.Application.LessThanOnePerson: {
        return 1;
      }
      default:
        return 0;
    }
  };

  const [panelDirection, setPanelDirection] = useState(100);
  const newPanelDirection = (input: Types.Category) => {
    setPanelDirection(core.category > input ? 100 : -100);
  };

  const transitions = useTransition(core.category, item => item, {
    from: { transform: "translate3d(" + panelDirection * -1 + "vw,0,0)" },
    enter: { transform: "translate3d(0px,0,0)" },
    leave: {
      transform: "translate3d(" + panelDirection + "vw,0,0)",
      position: "absolute"
    },
    config: {
      mass: 1,
      tension: 80,
      friction: 17,
      velocity: 2,
      precision: 0.001
    }
  });

  return (
    <div className={"page p-categories"}>
      <Slider
        core={{ get: core, set: (e: Types.Core) => setCore(e) }}
        type={core.category}
        typePrimitive={"category"}
        data={[
          { value: Types.Category.a, title: "a" },
          { value: Types.Category.b, title: "b" },
          { value: Types.Category.c, title: "c" }
        ]}
        getSliderLeft={() => getSliderLeft()}
        newPanelDirection={(e: any) => newPanelDirection(e)}
        style={{ maxWidth: 360 }}
      />
      {core.classification !== Types.Classification.III &&
        core.classification !== Types.Classification.IV &&
        core.category !== Types.Category.a &&
        core.category !== Types.Category.b &&
        core.application !== Types.Application.HumanComfort && (
          <Slider
            core={{ get: core, set: (e: Types.Core) => setCore(e) }}
            type={core.application}
            typePrimitive={"application"}
            data={[
              {
                value: Types.Application.OtherApplications,
                title: `1 or more person per 10 m²`,
                mobile: `1≥ person/10m²`
              },
              {
                value: Types.Application.LessThanOnePerson,
                title: `<1 Person per 10 m²`,
                mobile: `<1 person/10m²`
              }
            ]}
            getSliderLeft={() => getSliderLeft2()}
            style={{ maxWidth: 650 }}
            mobileWidth={600}
          />
        )}
      {transitions.map(({ item, props, key }) => (
        <animated.div
          key={key}
          className={"details-panel"}
          style={{ ...props, display: "flex" }}
        >
          <div>
            <span className={"details-regular"}>
              {Category[item - 1].description}
            </span>
            <br />
            <span className={"details-colored"}>
              {Category[item - 1].example}
            </span>
          </div>
          <div style={{ minWidth: 180, marginLeft: 30, textAlign: "center" }}>
            {item === 1 && <CategoryImages.CategoryA />}
            {item === 2 && <CategoryImages.CategoryB />}
            {item === 3 && <CategoryImages.CategoryC />}
          </div>
        </animated.div>
      ))}
      <div className="buttons">
        <div onClick={() => prev()}>Back</div>
        <div onClick={() => next()}>Next</div>
      </div>
    </div>
  );
};
